import _ from 'underscore';
import React from 'react';
import PropTypes from 'prop-types';
import { PaginatedItemsPropType } from 'propTypes/common';

import Catalog from 'components/catalogs/Catalog';
import Grid from 'components/Grid';
import PublicationCard from 'components/cards/entities/PublicationCard';

import { renderPagination } from 'utils/helpers/pagination';

const ThemesCatalog = ({
	publications: { pagination, items },
	emptyMessage
}) => (
	<Catalog footer={renderPagination(pagination)} emptyMessage={emptyMessage}>
		{!_.isEmpty(items) && (
			<Grid
				colDefault={1}
				colMobileMedium={2}
				colMobileLarge={3}
				colTabletMedium={4}
			>
				{items.map((publication) => (
					<PublicationCard entity={publication} key={publication._id} />
				))}
			</Grid>
		)}
	</Catalog>
);

ThemesCatalog.propTypes = {
	publications: PaginatedItemsPropType.isRequired,
	emptyMessage: PropTypes.string
};

export default ThemesCatalog;
